import { useSelector } from 'react-redux'
import { setWindowGA } from '../../helpers/DTM'
import { RootState } from '../../redux/store'
import { offerBannerType } from '../../types/components'
import { GA } from '../../constants'
import { AllBannerWrapper, BannerWrapper, BannerImage } from './style'

const OfferBanners = ({
	OFFER_BANNER,
	votingAvailable,
	phoneNo,
	scratch,
	customStyle,
}: offerBannerType) => {
	const metaData = useSelector((state: RootState) => state.meta)
	const userData = useSelector((state: RootState) => state.user)

	const sendGAData = (value: string, destinationUrl: string) => {
		const dtmData = {
			event: GA.eventName,
			offerClicked: value,
			offerDestination: destinationUrl,
			platform: metaData.platform,
		}
		setWindowGA(dtmData)
		window.clevertap.event.push('Pages Viewed', {
			'Page Name': scratch
				? GA.scratchCardPage
				: votingAvailable
				? GA.votingClosedPage
				: GA.thankYouPage,
			Phone: phoneNo,
			ctaname: value,
		})
	}

	return (
		<AllBannerWrapper>
			{OFFER_BANNER?.map((banner, index) => (
				<BannerWrapper
					key={index}
					onClick={() =>
						sendGAData(banner.ANALYTICS_CTA_NAME, banner.BANNER_URL)
					}
					customStyle={customStyle}
				>
					<a
						href={
							customStyle
								? banner.BANNER_URL.replace(
										'{couponCode}',
										userData?.userWinning?.lkPriceText
								  )
								: banner.BANNER_URL
						}
						target="_blank"
						rel="noreferrer"
					>
						<BannerImage src={banner.BANNER_IMAGE} />
					</a>
				</BannerWrapper>
			))}
		</AllBannerWrapper>
	)
}

export default OfferBanners
